import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button, Input, Card } from '../components/ui';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { isConfigured } from '../supabase/supabase';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const { error: authError } = await login(email, password);

    if (authError) {
      setError('Credenciales incorrectas. Verifica tu email y contraseña.');
    } else {
      navigate('/dashboard');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-brand-bg p-4">
      <div className="mb-8 text-center">
        <div className="w-16 h-16 bg-brand-dark rounded-xl mx-auto flex items-center justify-center mb-4 shadow-lg">
          <span className="text-brand-accent text-3xl font-black">B</span>
        </div>
        <h1 className="text-3xl font-bold text-brand-dark">Blue Blue On</h1>
        <p className="text-brand-text mt-2">Panel interno de gestión</p>
      </div>

      <Card className="w-full max-w-md p-8 shadow-xl">
        <form onSubmit={handleSubmit}>
          <Input
            label="Correo electrónico"
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@blueblueon.com"
            required
          />
          <Input
            label="Contraseña"
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
          />

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg flex items-center gap-2 text-sm text-red-700">
              <SafeIcon icon={FiIcons.FiAlertCircle} className="flex-shrink-0" />
              {error}
            </div>
          )}

          <Button
            type="submit"
            disabled={loading}
            className="w-full py-3 text-base flex justify-center items-center gap-2 mb-4"
          >
            {loading ? (
              <>
                <SafeIcon icon={FiIcons.FiLoader} className="animate-spin" />
                Entrando...
              </>
            ) : (
              <>
                Entrar al panel
                <SafeIcon icon={FiIcons.FiArrowRight} />
              </>
            )}
          </Button>
        </form>

        {!isConfigured && (
          <div className="mt-2 p-4 bg-brand-light rounded-lg flex items-start gap-3">
            <SafeIcon icon={FiIcons.FiInfo} className="text-brand-primary mt-0.5 flex-shrink-0" />
            <p className="text-xs text-brand-text">
              <strong>Modo demo:</strong> Supabase no configurado. Introduce cualquier email y contraseña para acceder.
            </p>
          </div>
        )}
      </Card>
    </div>
  );
};

export default Login;